import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route,useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeProvider} from "styled-components";
import { GlobalStyle } from "@chakra-ui/react";
// Screens
import Landing from "./screens/Landing.jsx";
import Signup from "./component/Signup/index.jsx";
import Login from "./component/Login/index.jsx";
import ProfileLayout from "./component/Profile_new/ProfileLayout";
import Pabout from "./component/Profile_new/Pabout";
import PEducation from "./component/Profile_new/PEducation";
import PJobProfile from "./component/Profile_new/PJobProfile";
import PPosition from "./component/Profile_new/PPosition";
import Paccomplishments from "./component/Profile_new/Paccomplishments";
import Pvol from "./component/Profile_new/Pvol";
import RsopForm from "./component/Rsop/RsopForm.jsx";
import RsopHome from './component/Rsop/RsopHome.jsx';
import OrderSummary from './component/Rsop/OrderSummary.jsx';
import FileUp from './component/Rsop/FileUp.tsx';

import Layout from './component/TrialDash/layouts/RootLayout.jsx';
import AllApps from './component/TrialDash/pages/AllApps.jsx';
import Authentication from './component/TrialDash/pages/Authentication.jsx';
import Analytics from './component/TrialDash/pages/Analytics.jsx';
import Build from './component/TrialDash/pages/Build.jsx';
import Settings from './component/TrialDash/pages/Settings.jsx';
import Stroage from './component/TrialDash/pages/Stroage.jsx';
import SignUpForms from "./component/Registration/LogIn.js";
import EmailVerify from "./component/EmailVerify/index.jsx";
// import VerifyOTP from "./component/Signup/email.js";

import Qna from './component/SopQna/Qna.jsx';
import Profile_detail from './component/TrialDash/pages/Profile_detail.jsx';

import OurProducts from './component/Products/OurProducts.jsx';
import P1Lan from './component/Products/P1Lan.jsx';
import PaymentComponent from "./component/Payment/PaymentComponent.js";
import PaySuccess from "./component/Payment/PaySuccess.jsx";
import OrderDetail from "./component/TrialDash/pages/OrderDetail.jsx";
import ResetPassWord from "./component/ResetPass/index.jsx"
import InputMail from "./component/ResetPass/InputMail.jsx";


export default function App() {
  const theme ={
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgb(24 24 29)",
      white: "#fff",
      black: " #212529",
      helper: "#c12031",
      bg: "rgb(249 249 255)",
      footer_bg: "#0a1435",
      btn: "#c12031",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: { mobile: "768px", tab: "998px" },
  };
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };
  return (
    <ChakraProvider>
    <ThemeProvider theme={theme} >
    <GlobalStyle/>
    <React.Fragment>
    <Router>
    <ScrollToTop />
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/Login" element={<Login />}/>
        <Route path="/signup" element={<Signup/>}/>
        <Route path="/forgetpassword" element={<InputMail/>}/>
        <Route path="/reset/password/:email/:token/:old" element={<ResetPassWord/>}/>
        <Route path="/api/users/:id/verify/:token" element={<EmailVerify />} />
        <Route path="/signupRoutes" element={<SignUpForms/>}/>
        <Route path="/ProfileLayout" element={<ProfileLayout/>}>
          <Route index element={<Pabout/>}/>
          <Route path="PEducation" element={<PEducation/>}/>
          <Route path="PJobProfile" element={<PJobProfile/>}/>
          <Route path="PPosition" element={<PPosition/>}/>
          <Route path="Pabout" element={<Pabout/>}/>
          <Route path="Paccomplishments" element={<Paccomplishments/>}/>
          <Route path="Pvol" element={<Pvol/>}/>
        </Route>
        <Route path="/RsopHome" element={<RsopHome />}/>
        {/* Rsop routes */}
        <Route path="/RsopHome" element={<RsopHome />}/>
        <Route path="/RsopForm" element={<RsopForm />}/>
        <Route path="/Fileup" element={<FileUp />}/>
        <Route path="/OrderSummary" element={<OrderSummary />}/>

        <Route path="/TrialDash" element={<Layout />}>
                <Route path="allApps" element={<AllApps />} />
                <Route path="authentication" element={<Authentication />} />
                <Route path="stroage" element={<Stroage />} />
                <Route path="settings" element={<Settings />} />
                 <Route path="auth" element={<Profile_detail />} />
                 <Route path="OrderDetail" element={<OrderDetail />} />

        </Route>

        <Route path="/qna" element={<Qna />} />
           {/* PRODUCT PAGES BELOW */}
              <Route path="/OurProducts" element={<OurProducts />} />
              <Route path="/Product1" element={<P1Lan />} />

              <Route path="/Payment" element={<PaymentComponent />} />
              <Route path="/Success" element={< PaySuccess/>} />
      </Routes>
    </Router>
    </React.Fragment>
    </ThemeProvider>
    </ChakraProvider>
  );
}
